import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { CartDrawer } from './CartDrawer'

export function Layout() {
  return <><Header /><main><Outlet /></main><Footer /><CartDrawer /></>
}
